import { ButtonGroup } from "@blueprintjs/core";
import * as React from "react";
import { EditButton, ViewButton } from ".";
import { UserAction } from "../api";
import { ERoutes } from "../AppRouter";
import { useAuth } from "../contexts";
import { useCommonHooks } from "../hooks";

export interface ISecuredGridActionsProps {
  route: ERoutes;
  viewActions?: UserAction[];
  editActions: UserAction[];
  idValue: number;
  tab?: string;
}

export const SecuredGridActions: React.FunctionComponent<
  ISecuredGridActionsProps
> = ({ route, viewActions = [], editActions, idValue, tab = "details" }) => {
  const { hasAction } = useAuth();
  const { router } = useCommonHooks();
  const canEdit = React.useMemo(
    () => hasAction(editActions),
    [editActions, hasAction]
  );
  const canView = React.useMemo(
    () => hasAction(viewActions),
    [hasAction, viewActions]
  );
  return (
    <ButtonGroup large={true}>
      <EditButton
        disabled={!canEdit}
        onClick={() => router.goToEditPage(route, idValue, "details", "edit")}
      />
      <ViewButton
        disabled={!canView}
        onClick={() => router.goToEditPage(route, idValue, "details", "view")}
      />
    </ButtonGroup>
  );
};
